export const APPLY_LEAVE_CODES = ["PL", "CL", "UL"] as const;
export type ApplyLeaveCode = (typeof APPLY_LEAVE_CODES)[number];

export function remainingOf(row: { allocated: number; used: number; pending: number }) {
  return Number((Number(row.allocated) - Number(row.used) - Number(row.pending)).toFixed(2));
}

export function codeOf(type?: { code?: string } | null) {
  return String(type?.code || "").toUpperCase();
}
